import React from 'react';
import classnames from 'classnames';
import style from './heading.scss';
import PropTypes from 'prop-types';

const comparator = (compareTo) => (val) => val === compareTo;

export const APPEARANCES = {
  H1: 'H1',
  H2: 'H2',
  H3: 'H3',
  H4: 'H4',
  H5: 'H5',
  H6: 'H6',
};

export const Heading = ({
  appearance = APPEARANCES.H1,
  isCategoryTitle = false,
  light = false,
  children,
  className = '',
  ...rest
}) => {
  const getClassNames = () =>
    classnames({
      [style.heading]: true,
      [style.h1Category]:
        isCategoryTitle && comparator(APPEARANCES.H1)(appearance),
      [style.h1]: comparator(APPEARANCES.H1)(appearance),
      [style.h2]: comparator(APPEARANCES.H2)(appearance),
      [style.h3]: comparator(APPEARANCES.H3)(appearance),
      [style.h4]: comparator(APPEARANCES.H4)(appearance),
      [style.h5]: comparator(APPEARANCES.H5)(appearance),
      [style.h6]: comparator(APPEARANCES.H6)(appearance),
      [style.light]: light,
    });
  const { dataHook, ...headingProps } = rest;

  return React.createElement(
    appearance.toLowerCase(),
    {
      ...headingProps,
      'data-hook': dataHook,
      className: `${getClassNames()} ${className}`,
    },
    children,
  );
};

Heading.displayName = 'Heading';

Heading.propTypes = {
  children: PropTypes.any,
  light: PropTypes.bool,
  appearance: PropTypes.oneOf(Object.keys(APPEARANCES)),
};
